const initialApIState = {
    loading: true
}


export default function apiexecutionstatus(state = initialApIState, action) {

    switch (action.type) {
        case "API_EXECUTION_START":
            return {
                ...state,
                loading: false,
         }
        case "API_EXECUTION_END":
        return {
            ...state,
            loading: true
        }
        default:
        return state;
    }
}